/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import {
  SOCIALNETWORKDATA_LOAD,
  SOCIALNETWORKDATA_LOAD_SUCCESS,
  SOCIALNETWORKDATA_LOAD_FAILURE,
} from "./SocialNetworkActionTypes";
import { ISocialNetworkData } from "../../Interfaces/SiteContent";

/**
 *
 */
export interface IGetSocialNetwork {
  type: typeof SOCIALNETWORKDATA_LOAD;
}

/**
 *
 */
export interface IGetSocialNetworkSuccess {
  type: typeof SOCIALNETWORKDATA_LOAD_SUCCESS;
  socialNetworks: ISocialNetworkData[];
}

/**
 *
 */
export interface IGetSocialNetworkFailure {
  type: typeof SOCIALNETWORKDATA_LOAD_FAILURE;
  socialNetworkLoadError: string;
}

/**
 *
 */
export const getSocialNetwork = (): SocialNetworkActionTypes => ({
  type: SOCIALNETWORKDATA_LOAD,
});

/**
 *
 * @param socialNetworks
 */
export const getSocialNetworkSuccess = (
  socialNetworks: ISocialNetworkData[]
): SocialNetworkActionTypes => ({
  type: SOCIALNETWORKDATA_LOAD_SUCCESS,
  socialNetworks,
});

/**
 *
 * @param errorMessage
 */
export const getSocialNetworkFailure = (
  socialNetworkLoadError: string
): SocialNetworkActionTypes => ({
  type: SOCIALNETWORKDATA_LOAD_FAILURE,
  socialNetworkLoadError,
});

export type SocialNetworkActionTypes =
  | IGetSocialNetwork
  | IGetSocialNetworkSuccess
  | IGetSocialNetworkFailure;
